import { registerCondition } from 'core/forms';

const isNotGoogleDrive = ({ model }) => ({
  hasCondition: model.source_content_type !== 'google_drive',
  condition: null,
});

registerCondition('isNotGoogleDrive', isNotGoogleDrive);

export default isNotGoogleDrive;
